/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SwitchToV4Container_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ShopContainer_user$ref: FragmentReference;
declare export opaque type ShopContainer_user$fragmentType: ShopContainer_user$ref;
export type ShopContainer_user = {|
  +id: string,
  +userId: ?string,
  +causeId: ?string,
  +$fragmentRefs: SwitchToV4Container_user$ref,
  +$refType: ShopContainer_user$ref,
|};
export type ShopContainer_user$data = ShopContainer_user;
export type ShopContainer_user$key = {
  +$data?: ShopContainer_user$data,
  +$fragmentRefs: ShopContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ShopContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "userId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "causeId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SwitchToV4Container_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8ce2edffdd4f27bcbe6477eb44cbdf90';
module.exports = node;
